import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import { Notification } from '@offerzen/pinata-shame'

import NonMatchingList from './NonMatchingList'
import MatchingRequirementsSkeleton from './MatchingRequirementsSkeleton'
import { getPositionMatchingRequirements } from './api'
import styles from './styles'

const MatchingRequirements = ({ jobId, candidateProfileId, requirementListHeading }) => {
  const { data, isLoading, isError } = useQuery(['positionMatchingRequirements', jobId, candidateProfileId], () => {
    return getPositionMatchingRequirements({ positionId: jobId, candidateProfileId })
  })

  if (isError) {
    return (
      <Notification theme="error">
        <div role="alert">Something went wrong.</div>
      </Notification>
    )
  }

  if (isLoading || !data) {
    return <MatchingRequirementsSkeleton />
  }

  const matchingRequirementsData = data.matchingRequirements
  const nonMatchingRequirements = Object.keys(matchingRequirementsData).filter(requirement => !matchingRequirementsData[requirement])

  if (nonMatchingRequirements.length === 0) return null

  return (
    <div>
      {requirementListHeading && <div className={styles.headingWrapper}>{requirementListHeading}</div>}
      <NonMatchingList nonMatchingRequirements={nonMatchingRequirements} />
    </div>
  )
}

MatchingRequirements.propTypes = {
  jobId: PropTypes.string,
  candidateProfileId: PropTypes.string,
  requirementListHeading: PropTypes.node,
}

export default MatchingRequirements
